import type { IndustryComparisonReportResponse } from "../api/types";
import { ReportItem } from "./ReportItem";

const groups = [["zpj", "总评价"], ["ylnl", "盈利能力"], ["yynl", "营运能力"], ["cznl", "偿债能力"], ["fznl", "发展能力"]] as const;
export function IndustryComparisonRenderer({ response }: { response: IndustryComparisonReportResponse }) {
  return <>{groups.map(([code, title]) => <section className="fa-report-chapter" id={`industry-${code}`} data-report-anchor={`industry-${code}`} key={code}><h2>{title}</h2><ReportItem item={response.result[code]} id={`industry-${code}-item`} /></section>)}</>;
}
